<template>
  <div class="hc-hexabars">
    <svg :style="style" class="hc-hexabars-chart">
      <hexabar
        v-for="bar in bars"
        :key="bar.id"
        :id="bar.id"
        :size="bar.size"
        :height="height"
        :width="bar.width"
        :x="bar.x"
        :scale="bar.scale"
        :onHover="onHover"
      />
      <text-axis
        :scaleFunction="bandScale"
        :scale="scale"
        :height="height * .85"
        :offset="horizentalAxisOffset"
        color="#666"
        :data="data"
      />
      <vertical-axis
        :scaleFunction="scaleLinearY"
        :scale="scale"
        :width="width * .9"
        :offset="verticalAxisOffset"
        color="#666"
        unit="%"
      />
    </svg>
  </div>
</template>

<script>
import TextAxis from '../libraries/TextAxis'
import VerticalAxis from '../libraries/VerticalAxis'
import Hexabar from '../Hexabar'
import { scaleBand, scaleLinear } from 'd3-scale'
export default {
  name: 'HexaBarsChart',
  components: {
    Hexabar,
    TextAxis,
    VerticalAxis
  },
  props: {
    data: {
      type: Array,
      default () { return []}
    }
  },
  data () {
    return {
      width: 480,
      height: 360,
      Data: []
    }
  },
  mounted () {
    this.resize()
    window.addEventListener('resize', this.resize)
  },
  methods: {
    resize () {
      this.width = this.$el.offsetWidth
      this.height = this.$el.offsetHeight
    },
    onHover (e, id, gid) {
      // console.log(this.texts[gid] + ': ' + this.data[gid] + ' ' + this.unit)
    }
  },
  computed: {
    style () {
      return { height: `${this.height}px`, width: `${this.width}px` }
    },
    bandScale () {
      return scaleBand()
        .rangeRound([this.width * .1, this.width * .95])
        .domain(this.data.map(d => d.year))
        .padding(0)
    },
    scale () {
      return Math.min(this.bandScale.bandwidth() / 160, this.height * .9 / 540)
    },
    bars () {
      let bars = []
      for (let i = 0; i < this.data.length; i++) {
        bars.push({
          x: this.bandScale(this.data[i].year),
          width: this.bandScale.bandwidth(),
          size: this.data[i].value,
          scale: this.scale,
          id: i + 1
        })
      }
      return bars
    },
    horizentalAxisOffset () {
      return { top: 0, left: 0, bottom: this.height * .1, right: 0 }
    },
    verticalAxisOffset () {
      return { top: 0, left: 0, bottom: this.height - (this.height * this.scale + this.height * .09), right: this.width * .05 }
    },
    scaleLinearY () {
      return scaleLinear()
        .domain([100, 0])
        .rangeRound([this.height * .08 * this.scale, this.height * this.scale])
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resize)
  }
}
</script>

<style>

</style>
